import { render, staticRenderFns } from "./RiskAssessmentItem.vue?vue&type=template&id=953d9bcc"
import script from "./RiskAssessmentItem.vue?vue&type=script&lang=ts"
export * from "./RiskAssessmentItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports